import './css/base.css'
import { createApp } from 'vue'
import App from './components/App'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import * as Sentry from '@sentry/vue'
import './styles/element/index.scss'
import { registerGlobalComponents } from './globals'
import { plugin as unleashPlugin } from '@unleash/proxy-client-vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { config } from '@/lib/helpers/config.helpers'
import { ErrorHandler } from '@/lib'
import { setupInterceptors } from '@/api/httpClient'

const app = createApp(App)
app.use(store)
setupInterceptors(store)
app.use(router)
app.use(ElementPlus)
app.use(unleashPlugin, {
  config: {
    url: config.unleash.proxyUrl,
    clientKey: config.unleash.clientKey,
    refreshInterval: 15,
    appName: 'admin-app',
    disableMetrics: true,
    environment: config.environment,
  },
})
app.use(ErrorHandler)
app.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

registerGlobalComponents(app)

app.config.globalProperties.$filters = {
  formatDate(date) {
    return new Intl.DateTimeFormat('sv-SE').format(new Date(date))
  },
  formatNumber(number) {
    return parseFloat(number)
      .toFixed(2)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  },
}
if (config.environment !== 'local') {
  Sentry.init({
    app,
    dsn: config.sentryDsn,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    environment: config.environment,
  })
}

app.mount('#app')

export default app
